import React from 'react';
import {Vector3} from 'three';
import {Line, Text} from '@react-three/drei';

const DIMENSION_LINE_OFFSET = 0.04;
const DIMENSION_TEXT_OFFSET = 0.1;

interface IARModelDimensionProps {
  meshSize: Vector3;
  visible?: boolean;
}

const ARModelDimension = ({meshSize, visible = true}: IARModelDimensionProps) => {
  return (
    <>
      <Line
        key="dimensions-line"
        visible={visible}
        color="white"
        lineWidth={0.005}
        worldUnits
        points={[
          [-meshSize.x * 0.5 - DIMENSION_LINE_OFFSET, 0.01, meshSize.z * 0.5 + DIMENSION_LINE_OFFSET],
          [meshSize.x * 0.5 + DIMENSION_LINE_OFFSET, 0.01, meshSize.z * 0.5 + DIMENSION_LINE_OFFSET],
          [meshSize.x * 0.5 + DIMENSION_LINE_OFFSET, 0.01, -meshSize.z * 0.5 - DIMENSION_LINE_OFFSET],
          [meshSize.x * 0.5 + DIMENSION_LINE_OFFSET, meshSize.y, -meshSize.z * 0.5 - DIMENSION_LINE_OFFSET],
        ]}
      />
      <ARModelDimensionText
        key="width"
        text={`${meshSize.x.toFixed(2)}m`}
        position={[0, 0.01, meshSize.z * 0.5 + DIMENSION_TEXT_OFFSET]}
        rotation={[-Math.PI / 2, 0, 0]}
        visible={visible}
      />
      <ARModelDimensionText
        key="depth"
        text={`${meshSize.z.toFixed(2)}m`}
        position={[meshSize.x * 0.5 + DIMENSION_TEXT_OFFSET, 0.01, 0]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        visible={visible}
      />
      <ARModelDimensionText
        key="height"
        text={`${meshSize.y.toFixed(2)}m`}
        position={[meshSize.x * 0.5 + DIMENSION_TEXT_OFFSET + 0.12, meshSize.y * 0.5 + 0.01, -meshSize.z * 0.5]}
        visible={visible}
      />
    </>
  );
};

export default React.memo(ARModelDimension);

interface IARModelDimensionTextProps {
  text: string;
  position?: [number, number, number];
  rotation?: [number, number, number];
  visible?: boolean;
}

const ARModelDimensionText = ({text, position = [0, 0, 0], rotation = [0, 0, 0], visible = true}: IARModelDimensionTextProps) => {
  return (
    <Text
      visible={visible}
      scale={0.1}
      position={position}
      rotation={rotation}
      fontWeight="bold"
      outlineWidth={0.02}
      color="white"
      outlineColor="black">
      {text}
    </Text>
  );
};
